// The floor screens that get the native (Material 3) phone layout. One list,
// read by Layout (page styling + the app-bar slot), AttentionPanel (compact
// chip instead of the full panel) and the zero-select helper — so a screen is
// either native on a phone everywhere or nowhere. Desktop and tablet are never
// affected: every consumer also checks the phone breakpoint.
const NATIVE_PREFIXES = [
  '/purchase-booking',
  '/purchase-invoices',
  '/raw-material-pool',
  '/procurement-batches',
  '/procurement',
  '/preprocessing/phases',
  '/preprocessing/lot-check',
  '/production/entry',
  '/cold-storage/intake',
];

export function isNativeRoute(pathname = '') {
  return NATIVE_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`));
}

// Where AttentionPanel parks its chip on a native screen: a slot in the
// global top bar, rendered by Layout.
export const APPBAR_SLOT_ID = 'm3-appbar-slot';
